<template>
  <v-container class="container-custom">
    <Breadcrumbs
      :title="$t('modules.portalalumno.admission.photograph.title')"
      size="sm"
    ></Breadcrumbs>
    <DocumentLegend :documentationUploaded="photographDocsStatus()"/>
    <v-row class="general_description pl-3 mt-5">
      <h4 >{{ $t('modules.portalalumno.admission.photograph.description') }}</h4>
      <h4>
        <v-icon class="icon-alert pr-2 pb-1">mdi-alert-circle</v-icon>
          {{ $t('modules.portalalumno.admission.photograph.subtitle1') }}
        <v-icon class="pb-1" color="red" size="8px">mdi-asterisk</v-icon>
          {{ $t('modules.portalalumno.admission.photograph.subtitle2') }}
      </h4>
    </v-row>
    <v-dialog
      transition="dialog-top-transition"
      v-model="showPhoto"
      max-width="65%"
      max-height="65%"
    >
      <v-img :src="idImage" alt="Image" contain @click="showPhoto = false"/>
    </v-dialog>
    <div class="cards-container mt-10">
      <v-card
        v-for="(i, index) in normalDocumentationRequired.find(doc => doc.id == 46)?.subtypes || []"
        :key="index"
        outlined
        :class="['cards py-7 px-10',
          {
            'documentation-status--rejected': normalDocumentationRejected[i.id],
            'documentation-status--sendOk' : uploadStatus[index] === true,
            'documentation-status--sendBad' : uploadStatus[index] === false,
          }
        ]"
        :data-status-message="statusMessages[index]"
        :elevation="normalDocumentationRejected[index] ? 3 : 0"
        >
        <div>
          <h2 class="mt-4 mb-6"> {{ i.description}} </h2>
          <div class="mb-5">
            <h3>{{ $t('modules.portalalumno.admission.photograph.tecnic') }}</h3>
            <ul>
              <li v-if="i.id == 295">{{ $t('modules.portalalumno.admission.photograph.titleSize') }}</li>
              <li v-if="i.id == 296">{{ $t('modules.portalalumno.admission.photograph.minonSize') }}</li>
              <li v-if="i.id == 297">{{ $t('modules.portalalumno.admission.photograph.diplomaSize') }}</li>
              <li v-if="i.id == 298">{{ $t('modules.portalalumno.admission.photograph.childSize') }}</li>
              <li>{{ $t('modules.portalalumno.admission.photograph.tecnic1') }}</li>
              <li>{{ $t('modules.portalalumno.admission.photograph.tecnic2') }}</li>
              <li>{{ $t('modules.portalalumno.admission.photograph.tecnic3') }}</li>
            </ul>
          </div>
          <div class="mb-8">
            <h3>{{ $t('modules.portalalumno.admission.photograph.visual') }}</h3>
            <ul>
              <li>{{ $t('modules.portalalumno.admission.photograph.visual1') }}</li>
              <li>{{ $t('modules.portalalumno.admission.photograph.visual2') }}</li>
              <li>{{ $t('modules.portalalumno.admission.photograph.visual3') }}</li>
              <li>{{ $t('modules.portalalumno.admission.photograph.visual4') }}</li>
              <li>{{ $t('modules.portalalumno.admission.photograph.visual5') }}</li>
            </ul>
          </div>
          <div class="imgSmall_container">
            <v-img
              @click="toggleDialog(i.id)"
              class="img-open"
              :src="getImage(i.id)"
              alt="Imagen de ejemplo"
            />
            <span class="text-img" @click="toggleDialog(i.id)">{{ $t('modules.portalalumno.admission.photograph.seeExample') }}</span>
          </div>
        </div>
        <v-card
          outlined
          class="internal_card pa-6"
        >
          <h4 v-if="i.id == 295">{{ $t('modules.portalalumno.admission.photograph.titleSize1') }}</h4>
          <h4 v-if="i.id == 296">{{ $t('modules.portalalumno.admission.photograph.minonSize1') }}</h4>
          <h4 v-if="i.id == 297">{{ $t('modules.portalalumno.admission.photograph.diplomaSize1') }}</h4>
          <h4 v-if="i.id == 298">{{ $t('modules.portalalumno.admission.photograph.childSize1') }}</h4>
          <h5 class="mb-2">{{ $t('modules.portalalumno.admission.photograph.tecnic1') }}</h5>
          <v-container>
            <v-divider/>
            <v-list class="items-uploaded">
              <v-list-item
                v-for="(item, ind) in photographDocs.filter( item => item.subTypeId == i.id) || []"
                :key="ind"
              >
                <v-list-item-content>
                  <div class="mb-3">
                      <h4 class="status_title mr-3">{{$t('modules.portalalumno.admission.documentation.statusDoc') }}</h4>
                      <v-icon class="mr-2" :class="item.statusClass">{{ item.statusIcon }}</v-icon>
                        <h4 class="status_meaning">{{ item.meaning }}</h4>
                  </div>
                  <div style="width: 100%;">
                      <v-list-item-title class="file_meaning">{{ item.filename }}</v-list-item-title>
                      <v-icon
                        v-if="item.meaning !== 'Cargado temporalmente'"
                        class="file_icon"
                        color="primary"
                        @click="downloadFile(item)">mdi-cloud-download-outline</v-icon>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-container>
          <FileUploader
            v-if="showFileUploader(i.id)"
            :isMultiple="true"
            limitSizeBytes="1000000"
            formatsAccepted=".jpg,.jpeg,.png"
            :documentation="documentation"
            :files.sync="newDocumentation[index]"
            :finished="finished"
            :resolutionLimits="getResolutionLimits(i.id)"
          />
        </v-card>
      </v-card>
      <Button
        class="btn-container pb-8"
        primary
        :text="$t('modules.portalalumno.admission.documentation.sendPhoto')"
        :loading="sendButton.loading"
        :success="sendButton.success"
        :error="sendButton.error"
        :successText="$t('actions.sent')"
        :errorText="'Error'"
        @end="resetButtonValues"
        @clicked="sendPhotographs"
        :disabled= "$v.newDocumentation.$invalid || finished"
      />
    </div>
  </v-container>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs'
import { mapMutations } from 'vuex'
import Button from '@/components/Button/Button'
import FileUploader from '@/components/FileUploader/FileUploader.vue'
import DocumentLegend from '../Components/DocumentLegend.vue'
import { $studentProcessing} from '../services'
import { mapGetters } from 'vuex'


  export default {
    name: 'PhotographDocumentation',
    components: {
      Breadcrumbs,
      DocumentLegend,
      FileUploader,
      Button,
    },
    props: {
      normalUploadedDocs: Array,
      normalDocumentationRequired: Array,
      documentationUploaded: Array,
    },
    data(){
      return{
        loading: false,
        sendButton: {
          loading: false,
          success: false,
          error: false,
        },
        showPhoto: false,
        idImage: null,
        uploadStatus: [],
        statusMessages: [],
        documentation: {},
        newDocumentation: Array(this.normalDocumentationRequired.length).fill(null).map(() => []),
        documentationUploadedFiltred: [],
        toUpload:[],
        finished: null,
      }
    },
    validations: {
      newDocumentation: {
        $validator: (value) => value.some(subArray => subArray.length > 0)
      }
    },
    computed: {
      ...mapGetters({
          studentRegister: 'commons/getStudentActualRegister',
          studentId: 'commons/getStudentId',
          studentData: 'commons/getStudentData',
          studentUserId: 'commons/getStudentUserID'
      }),
      showFileUploader() {
        const doc = (docId) => {
          const filter = this.photographDocs.filter(doc => doc.subTypeId === docId)
          if (!filter.length) return true
          const lastDoc = filter[filter.length - 1]
          return lastDoc.statusDoc === 95
        }
        return doc
      },
      normalDocumentationRejected() {
        const photographDocsFiltered = this.photographDocs.filter(doc => doc.documentationId === 46)
        const requiredSubtypes = this.normalDocumentationRequired.find(doc => doc.id === 46)?.subtypes || []
        return requiredSubtypes.reduce((acc, subtype) => {
          const docsForSubtype = photographDocsFiltered.filter(doc => doc.subTypeId === subtype.id)
          const lastDoc = docsForSubtype[docsForSubtype.length - 1]
          const isRejected = lastDoc ? lastDoc.statusDoc === 95 : false
          acc[subtype.id] = isRejected
          return acc
        }, {})
      },
      photographDocs() {
        const groupedDocs = []
        this.normalUploadedDocs.forEach(subArray => {
          subArray.forEach(item => {
            groupedDocs.push(item)
          })
        })
        return groupedDocs
      },
    },
    methods: {
      ...mapMutations('commons', [
        'setPendingPhotographs'
      ]),
      getResolutionLimits(id) {
        switch (id) {
          case 295:
            return { min: { width: 609, height: 963}, max: { width: 809 , height: 1163} }
          case 296:
            return { min: { width: 314, height: 491}, max: { width: 514, height: 691} }
          case 297:
            return { min: { width: 491, height: 727}, max: { width: 691, height: 927} }
          case 298:
            return { min: { width: 195, height: 254}, max: { width: 395, height: 454} }
          default:
            return { min: { width: 100, height: 300}, max: { width: 1000, height: 2000 } }
        }
      },
      async sendPhotographs() {
        this.toUpload = []
        this.getPhotographsPropsToSave(this.newDocumentation, this.normalDocumentationRequired)


        if (this.toUpload.length) {
          const groupedBySubtype = {}

          this.toUpload.forEach(photo => {
            const subtypeId = photo.idDocumentationSubtype
            if (!groupedBySubtype[subtypeId]) {
              groupedBySubtype[subtypeId] = []
            }
            groupedBySubtype[subtypeId].push(photo)
          })

          const currentPending = this.$store.state.commons.pendingPhotographs || {}
          const updatedPending = { ...currentPending }

          Object.entries(groupedBySubtype).forEach(([subtypeId, docs]) => {
            if (!updatedPending[subtypeId]) {
              updatedPending[subtypeId] = docs
            } else {
              const existingNames = new Set(updatedPending[subtypeId].map(d => d.file[0].name))
              docs.forEach(doc => {
                if (!existingNames.has(doc.file[0].name)) {
                  updatedPending[subtypeId].push(doc)
                }
              })
            }
          })

          this.setPendingPhotographs(updatedPending)
          this.finished = true
        }
         setTimeout(() => {
          this.$router.back()
        }, 1000)
      },
      async downloadFile(file){
        const fileDownload = (await $studentProcessing?.find(`/documentation/${file.id}`)).data
        if (fileDownload) {
          const link = document.createElement('a');
          link.download = file.filename;
          link.href = fileDownload;
          link.click();
        }
      },
      resetButtonValues() {
        this.sendButton.loading = false
        this.sendButton.success = false
        this.sendButton.error = false
      },
      getPhotographsPropsToSave(docs_array, docs_types_array) {
        const docFiltred = docs_types_array.find(doc => doc.id == 46)
        docs_array?.forEach((docType, docTypeIndex) => {
          if (docType.length > 0) {
            this.toUpload?.push({
              idDocumentationType: docFiltred.id,
              idDocumentationSubtype: docFiltred.subtypes[docTypeIndex]?.id,
              file: docType,
              index: docTypeIndex
            })
          }
        })
      },
      photographDocsStatus(){
        const doc = this.documentationUploaded
        return Array.isArray(doc) ? doc
          .filter(item => item.documentation.id === 46)
          .map(item => {
            return {
              ...item,
              documentation: {
                ...item.documentation,
                name: item.documentation.documentationSubtype?.description
              }
            }
          })
          : []
      },
      getImage(id){
        switch (id) {
          case 295:
            return '/assets/documents/photographs/OvaloTamanoTitulo.png'
          case 296:
            return '/assets/documents/photographs/OvaloTamanoMinon.png'
          case 297:
            return '/assets/documents/photographs/OvaloTamanoDiploma.png'
          case 298:
            return '/assets/documents/photographs/TamanoInfantil.png'
          default:
            return 'error'
        }
      },
      toggleDialog(id) {
        this.idImage = this.getImage(id)
        this.showPhoto = !this.showPhoto
      },
    }
  }
</script>


<style lang="sass" scoped>
@mixin display ($display: null, $align: null, $just: null)
  display: $display
  align-items: $align
  justify-content: if($just == 'end', 'flex-end', $just)
@mixin font ($size: null, $weight: normal, $color: black)
  font-size: $size
  font-weight: $weight
  color: $color
@mixin icon ($size: 20px, $padding: 1%, $color: null)
  font-size: $size
  padding: $padding
  color: $color


.general_description
  h4
    @include font ()
  .icon-alert
    color: #21D9E0
    font-size: 21px
.cards-container
  @include display (grid)
  gap: 4%
  h2
    @include font (20px, null, #0056FE)
  .cards
    @include display (grid)
    border: solid 2px #CCCDD1
    border-radius: 10px
    grid-template-columns: 50% 50%

  .documentation-status
    position: relative
    border-width: 1px
    border-style: solid
    background-color: red

    &--rejected
      border: 1px solid #ff8686 !important

    &--sendOk, &--sendBad
      &:before
        content: attr(data-status-message)
        position: absolute
        width: calc(100%)
        top: 1px
        left: 0px
        font-size: 14px
        padding: 5px 20px
        border: none
        border-radius: 10px 10px 0 0
        color: inherit

    &--sendOk
      border-color: #4CAF50 !important
      &:before
        background-color: #E8F5E9
        color: #4CAF50

    &--sendBad
      border-color: #FF5252 !important
      &:before
        background-color: #FFEBEE
        color: #FF5252

  .imgSmall_container
    position: relative
    width: 210px
    height: auto
    overflow: hidden
    .img-open
      margin-top: 10px
      cursor: pointer
      transition: filter 0.3s
    .img-open:hover
      filter: brightness(0.8)
    .img-open::after
      content: ''
      position: absolute
      top: 0
      left: 0
      right: 0
      bottom: 0
      background-color: rgba(0, 86, 254, 0.6)
    .text-img
      @include font (null, bolt, white)
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
      cursor: pointer

  .internal_card
    border-radius: 10px
    margin: auto 0
    .items-uploaded
      div
        @include display (flex)
      .status_title
        @include font (13px, null, null)
        @include display (flex, center, null)
      .icon-approved
        @include icon (21px, 2px, green)
      .icon-review
        @include icon (13px, 2px, white)
        width: 19px
        height: 19px
        border-radius: 50px
        background-color: #3D6CD9
      .icon-pending
        @include icon (21px, 2px, #FB8C00)
      .icon-rejected
        @include icon (21px, 2px, red)
      .status_meaning
        @include font (13px, null, gray)
        @include display (flex, center, null)
      .file_meaning
        @include display (block)
        @include font (19px, bold, #888D94)
        max-width: 80%
      .file_icon
        @include display (flex)
        margin-left: auto !important
    h4
      @include font (14px, bolt,gray)
    h5
      @include font (null, null, gray)
.btn-container
  @include display (flex, null ,end)
</style>
